<template>
    <v-layout
        class="service-notify"
        style="max-width: 1240px"
    >
        <h3>{{title}}</h3>
        <p class="service-notify-text">Мы вам напомним за 10 дней до окончания срока действия и в указанную вами дату, удобным для вас способом.</p>
        <v-form ref="notifyForm">
            <v-layout wrap row>
                <v-flex xs12 md4 lg3 class="service-notify-form-element">
                    <label>Напомним по СМС</label>
                        <v-flex xs12>
                            <v-text-field
                                v-model="notifyPhone"
                                :rules="[rules.required, rules.phone]"
                                label="Номер телефона"
                                mask="+7 ### ### ## ##"
                                validate-on-blur
                                required
                                ref="phoneNumber"
                                @input="inputPhone"
                            ></v-text-field>
                        </v-flex>
                        <v-layout row wrap v-show="showPhoneCodeInput">
                            <v-flex xs7 md10>
                                <v-text-field
                                    v-model="validatePhoneCode"
                                    :rules="[rules.phoneCode]"
                                    mask="#####"
                                    label="Введите код из СМС"
                                    validate-on-blur
                                    required
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs5 md2 class="small-button-block">
                                <v-btn
                                    @click="sendPhoneCode"
                                    :disabled="false"
                                    class="small-button block"
                                >
                                    Отправить код
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                <v-flex xs12 md4 lg3 class="service-notify-form-element">
                    <label>Напомним по e-mail</label>
                    <v-text-field
                        v-model="notifyEmail"
                        :rules="[rules.email]"
                        label="E-mail"
                        validate-on-blur
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 lg3 class="service-notify-form-element">
                    <label>Напомним в указанную дату</label>
                    <osago-date
                        v-model="notifyDate"
                        label="Дата"
                        :min="getMinDate()"
                        :max="getMaxDate()"
                    />
                </v-flex>
                <v-flex xs12 md4 lg3 class="service-notify-form-button">
                    <v-btn
                        class="button next-button block"
                        :loading="loading"
                        @click="checkCode"
                    >
                        Напомнить
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-form>
        <p>Нажимая на кнопку «Напомнить», соглашаюсь с <a :href="'https://getpolis.ru/osago_policy'">политикой обработки персональных данных</a></p>
    </v-layout>
</template>
<script>
    export default {
        props: ['title', 'requestResult', 'requestUrl', 'type'],
        data: () => ({
            notifyPhone: '+7',
            notifyEmail: '',
            notifyDate: '',
            validatePhoneCode: '',
            showPhoneCodeInput: false,
            loading: false,
            rules: {
                required: v => !!v || 'Обязательное поле',
                email: v => /.+@.+\..+/.test(v) || 'Неверный формат',
                phone: v => /^\d{11}$/.test(v) || 'Неверный формат',
                phoneCode: v=> /^\d{5}$/.test(v) || 'Неверный формат',
            },
        }),
        methods: {

            inputPhone() {
                this.showPhoneCodeInput = this.$refs.phoneNumber.validate()
            },

            sendPhoneCode() {
                axios.post('/create-pin/registration', {
                    phone: this.notifyPhone,
                }).then(response => {
                    PNotify.success('Код отправлен');
                }).catch(error => {
                    console.log(error.response);
                    PNotify.error(error.response.data.message);
                })
            },

            checkCode(){
                axios.post('/create-pin/verify', {
                    phone: this.notifyPhone,
                    code: this.validatePhoneCode,
                }).then(response => {
                    this.saveNotification()
                }).catch(error => {
                    console.log(error.response)
                    PNotify.error(error.response.data.message)
                })
            },

            saveNotification() {
                this.loading = true
                console.log(this.requestResult)
                axios.post(this.requestUrl, {
                    'phone' : this.notifyPhone,
                    'email' : this.notifyEmail,
                    'notifyDate' : this.notifyDate,
                    'userData' : this.requestResult,
                    'type' : this.type,
                })
                .then(response => {
                    if (response.data) {
                        PNotify.success('Напоминание создано успешно');
                    }
                })
                .catch(error => {
                    console.log(error.response)
                    PNotify.error(error.response.data.message)
                })
                .finally(() => {
                    this.$nextTick(() => {
                        this.loading = false
                    })
                })
            },

            getMinDate() {
                const date = new Date();
                return date.getFullYear() + '-' +
                    this.getZeroDate(date.getMonth() + 1) + '-' +
                    this.getZeroDate(date.getDate());
            },

            getMaxDate() {
                const date = new Date();
                return (date.getFullYear() + 5) + '-' +
                    this.getZeroDate(date.getMonth() + 1) + '-' +
                    this.getZeroDate(date.getDate());
            },

            getZeroDate(date) {
                return date < 10 ? date = '0' + date : date;
            },

        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/services/ServicesNotificationForm.vue